import { _ as u } from "./objectWithoutPropertiesLoose-2ffc4b6d.js";
import "./es.date.to-string-6ed49878.js";
import "./es.object.assign-7e79fd7b.js";
import "./es.object.to-string-f55666a8.js";
import "./es.regexp.to-string-e800d529.js";
import "./es.string.small-23219181.js";
import d from "styled-components";
import "./es.array.filter-4e9c9996.js";
import "./es.array.concat-d1c9b847.js";
import "./es.object.from-entries-0d7a0e54.js";
import "./es.array.map-d821aaf5.js";
import "./es.object.entries-d2a19275.js";
import "./es.string.replace-f4cc3aea.js";
import "./es.array.is-array-7a29277f.js";
import "react";
import "./web.dom-collections.for-each-3020ed11.js";
import { g as l } from "./getMetrics-953aa4f8.js";
import { jsx as r } from "react/jsx-runtime";
import "./export-cdcbfb2b.js";
import "./object-keys-719a5561.js";
import "./function-uncurry-this-clause-99074d1c.js";
import "./classof-21a3574e.js";
import "./to-string-92a62764.js";
import "./string-html-forced-a746405b.js";
import "./array-iteration-759bfbfa.js";
import "./create-property-f9780ed1.js";
import "./object-create-9b6715a2.js";
import "./html-32ef1b46.js";
import "./correct-is-regexp-logic-4465cd47.js";
import "./is-regexp-4c49b1c2.js";
import "./iterate-13ada9e5.js";
import "./object-to-array-0474b7e7.js";
import "./object-set-prototype-of-7d7e5736.js";
import "./function-apply-4756dee6.js";
import "./array-method-is-strict-e5a3c878.js";
var c = ["size", "emphasis", "type"], h = /* @__PURE__ */ d.div.withConfig({
  displayName: "badge__BadgeContainer",
  componentId: "tti681-0"
})(["--badge-text-color:", ";--badge-height:", ";--badge-min-width:", ";--badge-background-color:", ";--value-width:", ";padding:", ";display:", ";justify-content:", ";align-items:", ";height:var(--badge-height);width:", ";min-width:var(--badge-min-width);border-radius:", ";text-align:", ";background-color:var(--badge-background-color);box-sizing:", ";"], function(e) {
  if (e.emphasis === "high" || e.emphasis === void 0)
    return e.theme.components.badge.BadgeContainer.badgeTextColor.emphasis.high;
  if (e.emphasis === "low")
    switch (e.type) {
      case "primary":
        return e.theme.components.badge.BadgeContainer.badgeTextColor.emphasis.low.primary;
      case "neutral":
        return e.theme.components.badge.BadgeContainer.badgeTextColor.emphasis.low.neutral;
      case "danger":
        return e.theme.components.badge.BadgeContainer.badgeTextColor.emphasis.low.danger;
      case "success":
        return e.theme.components.badge.BadgeContainer.badgeTextColor.emphasis.low.success;
      case "warning":
        return e.theme.components.badge.BadgeContainer.badgeTextColor.emphasis.low.warning;
      default:
        return e.theme.components.badge.BadgeContainer.badgeTextColor.emphasis.low.default;
    }
}, function(e) {
  return (e == null ? void 0 : e.size) && e.theme.components.badge.getBadgeSize(e.size, e.value);
}, function(e) {
  return (e == null ? void 0 : e.size) && e.theme.components.badge.getBadgeSize(e.size, e.value);
}, function(e) {
  if (e.emphasis === "high" || e.emphasis === void 0)
    switch (e.type) {
      case "primary":
        return e.theme.components.badge.BadgeContainer.badgeBackgroundColor.emphasis.high.primary;
      case "neutral":
        return e.theme.components.badge.BadgeContainer.badgeBackgroundColor.emphasis.high.neutral;
      case "danger":
        return e.theme.components.badge.BadgeContainer.badgeBackgroundColor.emphasis.high.danger;
      case "success":
        return e.theme.components.badge.BadgeContainer.badgeBackgroundColor.emphasis.high.success;
      case "warning":
        return e.theme.components.badge.BadgeContainer.badgeBackgroundColor.emphasis.high.warning;
      default:
        return e.theme.components.badge.BadgeContainer.badgeBackgroundColor.emphasis.high.default;
    }
  else if (e.emphasis === "low")
    switch (e.type) {
      case "primary":
        return e.theme.components.badge.BadgeContainer.badgeBackgroundColor.emphasis.low.primary;
      case "neutral":
        return e.theme.components.badge.BadgeContainer.badgeBackgroundColor.emphasis.low.neutral;
      case "danger":
        return e.theme.components.badge.BadgeContainer.badgeBackgroundColor.emphasis.low.danger;
      case "success":
        return e.theme.components.badge.BadgeContainer.badgeBackgroundColor.emphasis.low.success;
      case "warning":
        return e.theme.components.badge.BadgeContainer.badgeBackgroundColor.emphasis.low.warning;
      default:
        return e.theme.components.badge.BadgeContainer.badgeBackgroundColor.emphasis.low.default;
    }
}, function(e) {
  return e.size === "small" ? e.theme.components.badge.BadgeContainer.valueWidth.small : e.theme.components.badge.BadgeContainer.valueWidth.default;
}, function(e) {
  var t;
  return (e == null || (t = e.value) == null ? void 0 : t.toString().length) === 1 || e != null && e.value ? e.theme.components.badge.BadgeContainer.padding.length[1] : e.theme.components.badge.BadgeContainer.padding.default;
}, function(e) {
  return e.theme.components.badge.BadgeContainer.display;
}, function(e) {
  return e.theme.components.badge.BadgeContainer.justifyContent;
}, function(e) {
  return e.theme.components.badge.BadgeContainer.alignItems;
}, function(e) {
  return e.theme.components.badge.BadgeContainer.width;
}, function(e) {
  return e.theme.components.badge.BadgeContainer.borderRadius;
}, function(e) {
  return e.theme.components.badge.BadgeContainer.textAlign;
}, function(e) {
  return e.theme.components.badge.BadgeContainer.boxSizing;
}), b = /* @__PURE__ */ d.span.withConfig({
  displayName: "badge__BadgeValue",
  componentId: "tti681-1"
})(["display:", ";justify-content:", ";align-items:", ";width:", ";height:", ";", ";color:var(--badge-text-color);text-align:", ";"], function(e) {
  return e.theme.components.badge.BadgeValue.display;
}, function(e) {
  return e.theme.components.badge.BadgeValue.justifyContent;
}, function(e) {
  return e.theme.components.badge.BadgeValue.alignItems;
}, function(e) {
  return e.theme.components.badge.BadgeValue.width;
}, function(e) {
  return e.size === "small" ? e.theme.components.badge.BadgeValue.height.small : e.size === "medium" ? e.theme.components.badge.BadgeValue.height.medium : e.theme.components.badge.BadgeValue.height.large;
}, function(e) {
  if (e.size === "small")
    return e.theme.components.badge.BadgeValue.textStyle.small;
  if (e.size === "medium")
    return e.theme.components.badge.BadgeValue.textStyle.medium;
  if (e.size === "large")
    return e.theme.components.badge.BadgeValue.textStyle.large;
}, function(e) {
  return e.theme.components.badge.BadgeValue.textAlign;
});
function X(e) {
  var t = e.size, n = t === void 0 ? "medium" : t, i = e.emphasis, g = i === void 0 ? "high" : i, o = e.type, m = o === void 0 ? "primary" : o, a = u(e, c), s = l({
    label: "Badge"
  });
  return /* @__PURE__ */ r(h, Object.assign({
    size: n,
    emphasis: g,
    type: m
  }, a, s, {
    children: /* @__PURE__ */ r(b, {
      role: "status",
      size: n,
      "aria-label": a.ariaLabel,
      "aria-live": "polite",
      children: a.value
    })
  }));
}
export {
  X as Badge
};
